export const LeadAgentLeadStateTypeId = {
  1: 'Active',
  3: 'Closed',
  2: 'Lost',
  4: 'Deleted',
  5: 'On Hold',
};

export const LeadAgentLeadStateType = {
  Active: 1,
  Closed: 3,
  Lost: 2,
  Deleted: 4,
  On_Hold: 5,
};
// export default class LeadAgentLeadStateType {};
